import { Controller } from "@hotwired/stimulus"

// Календарь публикаций: перетащить неотправленное на другой день. Нативный
// drag&drop; на отпускание заполняем скрытую форму и отправляем её (CSRF и
// редирект — как у обычной формы Rails).
export default class extends Controller {
  static targets = ["form", "type", "id", "date"]

  start(event) {
    const item = event.currentTarget
    event.dataTransfer.setData("text/plain", JSON.stringify({ type: item.dataset.type, id: item.dataset.id }))
    event.dataTransfer.effectAllowed = "move"
  }

  over(event) {
    event.preventDefault()
    event.currentTarget.classList.add("is-drop")
  }

  leave(event) {
    event.currentTarget.classList.remove("is-drop")
  }

  drop(event) {
    event.preventDefault()
    const day = event.currentTarget
    day.classList.remove("is-drop")
    let item
    try { item = JSON.parse(event.dataTransfer.getData("text/plain")) } catch { return }
    if (!item?.type) return

    this.typeTarget.value = item.type
    this.idTarget.value = item.id
    this.dateTarget.value = day.dataset.date
    this.formTarget.requestSubmit()
  }
}
